import { useState, useEffect } from "react";
import { sanity } from "../sanity";

const quizzesQuery = `*[_type=='quiz'] {
  _id,
  active,
  title,
  "questions": *[_type=='question' && references(^._id) && active == true] {
    _id,
    question,
    "answers": *[_type=='answer' && references(^._id)] {
      answer,
      correct,
      answer_description,
      icon {
        caption,
        asset-> {
          _id,
          metadata {
            lqip,
            dimensions
          }
        },
        "imageUrl": asset->url
      },
    }
  }
}`;

const useSanityData = () => {
  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuizzes = async () => {
      try {
        const quizzes = await sanity.fetch(quizzesQuery);
        setQuizzes(quizzes);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchQuizzes();
  }, []);

  return { quizzes, loading };
};

export default useSanityData;
